import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSEO, API } from "@/lib/seo";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const formatError = (detail) => {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return String(detail);
};

export default function AdminLogin() {
    useSEO("Admin Login | Digital Circle", "Digital Circle admin login.");
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
            localStorage.setItem("dc_admin_token", data.token);
            navigate("/admin/leads");
        } catch (err) {
            setError(formatError(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="flex min-h-screen items-center justify-center bg-slate-50 px-5" data-testid="admin-login-page">
            <div className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-10 shadow-sm">
                <Logo />
                <h1 className="mt-8 text-2xl font-black tracking-tighter text-slate-900">Admin login</h1>
                <p className="mt-2 text-sm text-slate-500">View and manage quote requests.</p>

                <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
                    <div className="space-y-2">
                        <Label htmlFor="a-email">Email</Label>
                        <Input id="a-email" data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" placeholder="admin@digitalcircle.ca" />
                    </div>
                    <div className="space-y-2">
                        <Label htmlFor="a-password">Password</Label>
                        <Input id="a-password" data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl" placeholder="••••••••" />
                    </div>
                    {error && (
                        <p className="rounded-xl bg-rose-50 px-4 py-3 text-sm font-medium text-rose-600" data-testid="admin-login-error">
                            {error}
                        </p>
                    )}
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-submit"
                        className="w-full rounded-full bg-slate-900 py-3.5 text-sm font-semibold text-white transition-[background-color,opacity] duration-300 hover:bg-slate-800 disabled:opacity-60"
                    >
                        {loading ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>
        </main>
    );
}
